import { Colors } from '@src/colors';
import styled from 'styled-components';

export const Label = styled.label`
    margin: auto 0;
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${Colors.dusk};
    white-space: nowrap;
`;
